export const ImgIframeSx = {
    width: '100%',
    height: '100%'
}
